<div class="body" [ngClass]="getBodyClass()">
  <router-outlet></router-outlet>
</div>
